// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getProductMaintenancePlans} from '../../shared/repositories';

export const updateMaintenancePlans = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getProductMaintenancePlans(pin);

            dispatch({
                payload,
                property: 'maintenancePlans',
                type: actions.UPDATE_PRODUCT_MAINTENANCE_PLANS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/maintenance-plan.js